import { PersonalSettings, DEFAULT_CURRENCY } from './PersonalSettings';
import { JsonObject } from '../types';
import { PdfReportsSettings } from './PdfReportsSettings';
import { ExportSettings } from './ExportSettings';
import { Mt940Settings } from './Mt940Settings';
import { Mt942Settings } from './Mt942Settings';
import { isImpersonatedUser } from '../helpers';

export class UserSettings {
  public personal?: PersonalSettings;
  public export?: ExportSettings;
  public mt940?: Mt940Settings;
  public mt942?: Mt942Settings;
  public pdfReports?: PdfReportsSettings;

  constructor(json: JsonObject) {
    this.personal =
      json.domainUser?.settings || json.impersonatedUser?.settings
        ? new PersonalSettings({
            ...(isImpersonatedUser(json) ? json.impersonatedUser?.settings : json.domainUser?.settings),
            gridSettings: json.gridSettings,
            paymentTemplates: json.client.applicationSettings.settings?.paymentTemplates || false,
            paymentValuesFromTemplate: json.client.applicationSettings.settings?.paymentValuesFromTemplate || false,
            consolidationCurrency: json.exportDownloadSettings
              ? {
                  code: json.exportDownloadSettings?.consolidationCurrency?.code || DEFAULT_CURRENCY.code,
                  fractionDigits:
                    json.exportDownloadSettings?.consolidationCurrency?.fractionDigits ||
                    DEFAULT_CURRENCY.fractionDigits,
                }
              : DEFAULT_CURRENCY,
          })
        : new PersonalSettings();
    this.export = isImpersonatedUser(json)
      ? new ExportSettings(json?.impersonatedUser?.settings)
      : new ExportSettings(json?.domainUser?.settings);
    this.mt940 = json.exportDownloadSettings ? new Mt940Settings(json.exportDownloadSettings) : new Mt940Settings();
    this.mt942 = json.exportDownloadSettings?.MT942
      ? new Mt942Settings(json.exportDownloadSettings.MT942)
      : new Mt942Settings();
    this.pdfReports = json.exportDownloadSettings ? new PdfReportsSettings(json.exportDownloadSettings) : undefined;
  }
}
